const SALUTATION = ['Herr', 'Frau', 'Keine Angabe'];

export default SALUTATION;
